import React from "react";
import styles from "./AreaTitle.module.css";
import { sanitizeHtml } from "../../utils/sanitizeHtml";

/**
 * Componente de título de área.
 * @param {string} Title - Título principal
 * @param {ReactNode} Icon - Ícone MUI
 * @param {string} Description - Descrição opcional
 * @param {'default'|'small'} size - Tamanho do componente (default = padrão, small = compacto)
 */
function AreaTitle({ Title, Icon, Description, size = 'default' }) {
    const desc = (Description) ? Description.replaceAll(/\n/g, '<br />') : "";
    
    const iconContainerStyle = {
        color: '#ffffff'
    };

    const isSmall = size === 'small';

    // Tamanho do ícone: menor quando compact
    const getIconSize = () => {
        if (isSmall) return 16;
        return window.innerWidth <= 768 ? 20 : 24;
    };

    const [iconSize, setIconSize] = React.useState(getIconSize);

    React.useEffect(() => {
        const handleResize = () => {
            setIconSize(getIconSize());
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSmall]);

    const containerClass = [
        styles.container,
        isSmall ? styles.containerSmall : ''
    ].filter(Boolean).join(' ');

    const iconClass = [
        styles.iconContainer,
        isSmall ? styles.iconContainerSmall : ''
    ].filter(Boolean).join(' ');

    return (
        <div className={containerClass}>
            {Icon && (
                <div className={iconClass} style={iconContainerStyle}>
                    {React.cloneElement(Icon, { sx: { fontSize: iconSize } })}
                </div>
            )}
            <div className={styles.containerTexts}>
                <h2
                    className={isSmall ? styles.titleSmall : ''}
                    style={{ whiteSpace: 'pre-line' }}
                >
                    {Title}
                </h2>
                {desc && (
                    <p
                        className={isSmall ? styles.descSmall : ''}
                        dangerouslySetInnerHTML={{ __html: sanitizeHtml(desc) }}
                    />
                )}
            </div>
        </div>
    );
}

export default AreaTitle;